import * as React from 'react';
import ThreeDotsHorizontalOutlined from './three-dots-horizontal-outlined';
import ThreeDotsHorizontalFilled from './three-dots-horizontal-filled';
import type { IconCombinedProps } from './types';
const ThreeDotsHorizontalCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ThreeDotsHorizontalFilled ref={ref} {...rest} />;
  }
  return <ThreeDotsHorizontalOutlined ref={ref} {...rest} />;
});
export default ThreeDotsHorizontalCombined;